import React from "react";
import buildColor from "@fdr/static-ui/ColorPalette";
import { promo, videoReplay } from "@fdr/static-ui/Icons/icons";
import Icon from "@fdr/static-ui/Icons";
import { IconType } from "@tvg/ts-types/Icons";
import { Container, Text } from "./styled-components";
import { DerbyColorVariant, DerbyLabelType } from "./types";

interface Props {
  text: string;
  colorVariants: DerbyColorVariant;
  derbyLabelType: DerbyLabelType;
  qaLabel?: string;
}

const renderIcon = (colorVariants: DerbyColorVariant, icon: IconType) => (
  <Icon
    color={buildColor(colorVariants.color, colorVariants.value)}
    icon={icon}
    size={16}
    qaLabel="derby-label-icon"
  />
);

const HomeHeaderLabel = ({
  qaLabel = "derbyLabel",
  text = "",
  colorVariants = { color: "white", value: "100" },
  derbyLabelType = "live"
}: Props) => (
  <Container data-qa-label={qaLabel} derbyLabelType={derbyLabelType}>
    {renderIcon(colorVariants, derbyLabelType === "live" ? videoReplay : promo)}
    <Text>{text}</Text>
  </Container>
);

export default HomeHeaderLabel;
